import React, { useContext } from 'react'
import M_DataGraph from './M_DataGraph'
import { Chart } from 'primereact/chart'
import './M_Graph.css'
import { LoadingContext } from '../M_Utils'

export function M_Graph({ type, label, subLabel, values, onClick, doughnutInner, icon, color, labelColor, value }) {
    const ctx = useContext(LoadingContext)

    color = color ? color : ctx.primaryColor ? ctx.primaryColor : 'var(--color-black)'
    labelColor = labelColor ? labelColor : ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)'

    const doughnutOptions = {
        cutout: 50,
        plugins: {
            legend: {
                position: 'bottom'
            }
        },
        animation: {
            duration: 0
        }
    }

    const pieOptions = {
        plugins: {
            legend: {
                position: 'bottom'
            }
        },
        animation: {
            duration: 0
        }
    }

    const lineOptions = {
        maintainAspectRatio: false,
        aspectRatio: 0.6,
        plugins: {
            legend: {
                position: 'bottom'
            }
        },
        animation: {
            duration: 0
        }
    }

    const columnOptions = {
        maintainAspectRatio: false,
        aspectRatio: 0.8,
        plugins: {
            tooltips: {
                callbacks: {
                    label: (context) => {
                        const label = context.dataset.label || '';

                        if (label) {
                            return `${label}: ${context.parsed.y} - additional text`;
                        }

                        return `${context.parsed.y} - additional text`;
                    },
                },
                mode: 'index',
                intersect: false,
                displayColors: false
            },
            legend: {
                display: false,
                position: 'bottom'
            }
        },
        animation: {
            duration: 0
        },
        scales: {
            x: {
                stacked: true,
                scaleLabel: {
                    display: true,
                    labelString: 'Y text'
                },
                ticks: {
                    color: 'black'
                },
                grid: {
                    color: '#EBEDED'
                }
            },
            y: {
                stacked: true,
                ticks: {
                    color: 'black',
                    precision: 0
                },
                grid: {
                    color: '#EBEDED'
                }
            }
        }
    }

    return (
        <>
            {type == "data" &&
                <M_DataGraph name={label} value={value} icon={icon} color={color} />
            }

            {type == "doughnut" &&
                <div className='DoughnutGraphMainDiv'>
                    <div className='DoughnutGraphLabels' style={{ color: labelColor }}>
                        {label}
                    </div>
                    <div className='DoughnutGraphLabels' style={{ color: labelColor }}>
                        {subLabel}
                    </div>
                    <Chart
                        id='myChart'
                        type={type}
                        options={doughnutOptions}
                        onClick={onClick}
                        data={values}
                        style={{ width: '200px', height: '200px' }}
                    />
                    <div className='DoughnutGraphInner' style={{ color: labelColor }}>
                        {doughnutInner}
                    </div>
                </div>
            }

            {type == "pie" &&
                <div className='PieGraphMainDiv'>
                    <div className='PieGraphLabels' style={{ color: labelColor, fontSize: '23px' }}>
                        {label}
                    </div>
                    <div className='PieGraphLabels' style={{ color: labelColor }}>
                        {subLabel}
                    </div>
                    {values?.datasets?.filter(data => (data.data.filter(elem => elem !== 0).length !== 0)).length === 0 ?
                        <h2 style={{ width: '200px' }}>Nothing to show</h2>
                        :
                        <Chart id='myChart' type={type} options={pieOptions} onClick={onClick} data={values} />
                    }
                </div>
            }

            {type == "bar" &&
                <div className='ColumnGraphMainDiv'>
                    <div className='ColumnGraphLabels' style={{ color: labelColor }}>
                        {label}
                    </div>
                    <div className='ColumnGraphLabels' style={{ color: labelColor }}>
                        {subLabel}
                    </div>
                    <Chart type={type} options={columnOptions} onClick={onClick} data={values} />
                </div>
            }

            {type === "line" &&
                <div className='ColumnGraphMainDiv'>
                    <div className='ColumnGraphLabels' style={{ color: labelColor }}>
                        {label}
                    </div>
                    <div className='ColumnGraphLabels' style={{ color: labelColor }}>
                        {subLabel}
                    </div>
                    <Chart type={type} data={values} options={lineOptions} onClick={onClick} />
                </div>
            }
        </>
    )
}